// Opções de domínio da Tabela de frete.
// As listas em si vêm da API (GET /tabelafrete/jsonlistgeral → state.options);
// aqui ficam só os valores fixos e o mapa de cor das tags da listagem.

// Modal é fixo por ora (campo desabilitado na tela de Identificação).
export const MODAL_PADRAO = "Rodoviário";

// tp_calc = 5 (Viagem): o único tipo em que a rota é definida por roteiro. Nos
// demais o trajeto é origem→destino, por município ou região (como no legado).
// tp_receita_despesa: receita exige cliente/tomador.
export const FREIGHT_TABLE_CALC_VIAGEM = 5;
export const FREIGHT_TABLE_CALC_FAIXA_PESO_VEICULO = 8;
/** Label exibido na UI para tp_calc = 8 (independente do texto em list_item_valor). */
export const FREIGHT_TABLE_CALC_FAIXA_PESO_VEICULO_LABEL = "Faixa peso Veículo";
export const FREIGHT_TABLE_TIPO_RECEITA = 1;
export const FREIGHT_TABLE_TIPO_DESPESA = 2;

// Opções dos radios da Identificação, fixas no front: são domínio fixo (list_item_valor) e vir da
// API as fazia esperar os ~6 MB do jsonlistgeral, que traz municípios e todas as tabelas de frete.
export const TP_TABELA_OPTIONS = [
  { value: 2, label: "Fracionada" },
  { value: 1, label: "Lotação" },
];
export const TP_RECEITA_DESPESA_OPTIONS = [
  { value: 2, label: "Tabela despesa" },
  { value: 1, label: "Tabela receita" },
];
export const TP_COMPOSICAO_OPTIONS = [
  { value: 1, label: "Simples" },
  { value: 2, label: "Tabela composta" },
  { value: 3, label: "Tabela de composição" },
];

// tp_origem/tp_destino: 1 = município, 2 = região (FREIGHT_TABLE_API.md §4.8).
export const ROUTE_LOCALITY_MUNICIPIO = 1;
export const ROUTE_LOCALITY_REGIAO = 2;

// tp_receita_despesa: 1 Receita, 2 Despesa.
export const FREIGHT_TABLE_TIPO_VARIANT = {
  1: "success",
  2: "warning",
};

// tp_calc: destaque só para Viagem (5); os demais caem no "neutral" do consumidor.
export const FREIGHT_TABLE_CALCULO_VARIANT = {
  5: "info",
};

export const SUPPLIER_SEARCH_MIN_LENGTH = 3;

// tp_calc 4 Tonelada, 5 Viagem, 6 Comissão, 7 % NF: nesses tipos o backend não
// exige vlr_ini/vlr_fim/fixa nas faixas (FREIGHT_TABLE_API.md §4.8).
export const CALC_TYPES_WITHOUT_RANGES = [4, 5, 6, 7];

// Faixa de peso (1), de KM (2) e de volume (3) exigem vlr_ini e vlr_fim ≠ 0 sem
// sobreposição; nos outros a vigência tem um valor único.
export function calcRequiresRanges(tpCalc) {
  if (tpCalc === null || tpCalc === undefined) return false;
  return CALC_TYPES_WITHOUT_RANGES.indexOf(Number(tpCalc)) === -1;
}

export const FREIGHT_TABLE_CALC_FAIXA_PESO = 1;

export function calcUsesVehicle(tpCalc) {
  return Number(tpCalc) !== FREIGHT_TABLE_CALC_FAIXA_PESO;
}

export function calcUsesItinerary(tpCalc) {
  return Number(tpCalc) === FREIGHT_TABLE_CALC_VIAGEM;
}

const RANGE_BLOCK_TITLES = {
  1: "Faixa de peso",
  2: "Faixa de km",
  3: "Faixa de volume",
  8: "Faixa de peso",
};

export function describeRangeBlockTitle(tpCalc) {
  return RANGE_BLOCK_TITLES[Number(tpCalc)] || "Faixas de cálculo";
}

export function calcIsFaixaPesoPorVeiculo(tpCalc) {
  return Number(tpCalc) === FREIGHT_TABLE_CALC_FAIXA_PESO_VEICULO;
}

/** Ajusta labels de domínio exibidos na tela (sem depender do texto do LIV). */
export function mapTpCalcOptionLabel(opt) {
  if (!opt) return opt;
  if (Number(opt.value) === FREIGHT_TABLE_CALC_FAIXA_PESO_VEICULO) {
    return { ...opt, label: FREIGHT_TABLE_CALC_FAIXA_PESO_VEICULO_LABEL };
  }
  return opt;
}

// tp_processo: valor 1 = "Não definido", o default do legado (TabelaFreteForm.vue:3704).
// tp_operacao usa o mesmo valor, mas nasce vazio (TMS-8590).
export const TP_NAO_DEFINIDO = 1;

// tp_composicao = 1 (Tabela simples): único valor oferecido pela etapa 3 — 2 e 3
// exigem o multiselect "Tabela de frete" do legado, que a UI nova não tem (ADR-0013 §2).
export const FREIGHT_TABLE_COMPOSICAO_SIMPLES = 1;

// FREIGHT_TABLE_API.md §4.8.6: taxa_comissao é decimal(5,3), só 2 dígitos
// inteiros. Os demais numéricos são decimal(16,4), inalcançáveis pela tela.
export const CUSTO_EXTRA_MAX = {
  taxa_comissao: 99.999,
};
